export default __webpack_public_path__ + "static/Inter-Regular-subset-ec430d0f0a9480b4882985ce82e585db.woff2";